import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import placeholder from "../../Assets/pre.svg";
import { motion } from "framer-motion";
import { projects } from "../../data/profile";

function Projects() {
  return (
    <Container fluid className="project-section">
      <div id="projects" />
      <Particle />
      <Container>
        <motion.h1
          className="project-heading"
          initial={{ opacity: 0, y: 14 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.4 }}
          transition={{ duration: 0.5, ease: "easeOut" }}
        >
          My Recent <strong className="purple">Works </strong>
        </motion.h1>
        <motion.p
          style={{ color: "white" }}
          initial={{ opacity: 0, y: 10 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.4 }}
          transition={{ duration: 0.45, ease: "easeOut", delay: 0.05 }}
        >
          Here are a few projects I've worked on recently.
        </motion.p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          {projects.map((p, idx) => (
            <Col key={p.title} md={4} className="project-card">
              <motion.div
                initial={{ opacity: 0, y: 16 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.2 }}
                transition={{
                  duration: 0.5,
                  ease: "easeOut",
                  delay: (idx % 3) * 0.05,
                }}
              >
                <ProjectCard
                  imgPath={p.image ?? placeholder}
                  isBlog={false}
                  title={p.title}
                  description={p.description}
                  oneLiner={p.oneLiner}
                  problem={p.problem}
                  solution={p.solution}
                  impact={p.impact}
                  tags={p.tags}
                  stack={p.stack}
                  ghLink={p.links?.github}
                  demoLink={p.links?.demo}
                />
              </motion.div>
            </Col>
          ))}
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
